<!-- App.vue -->
<template>
  <router-view />
</template>

<script setup>
</script>

<style>
@import './assets/font-2026/epilogue.css';

/* --- Global & Body --- */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html, body {
  /* Pastikan body dan html bisa mengisi layar */
  height: 100%;
  width: 100%;
  overflow-x: hidden; /* Mencegah scroll horizontal */
}

body {
  font-family: 'Epilogue', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f1f1f1;
}

/* [BACKGROUND UTAMA] */
.fixed-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: -1;
  overflow: hidden;

  /* Dark navy canvas — let the colourful assets do the talking */
  background: linear-gradient(160deg, #fff 0%, #f2f2f2 45%, #fff 100%);
}

/* ---- Dekorasi aset — base rule ---- */
.deco {
  position: absolute;
  pointer-events: none;
  user-select: none;
  /* Promote each deco image to its own compositor layer on iOS Safari.
     This prevents them from causing full-page repaints. */
  will-change: transform;
  transform: translateZ(0);
}

/* === Per-asset positioning & rotation === */

/* PP26-01 — swoosh biru, sudut kiri atas mengalir ke kanan */
.deco--01 {
  width: 320px;
  top: -30px;
  left: -40px;
  transform: rotate(-18deg);
  opacity: 0.55;
}

/* PP26-02 — swoosh pink, sudut kanan atas dibalik */
.deco--02 {
  width: 280px;
  top: -20px;
  right: -30px;
  transform: rotate(160deg);
  opacity: 0.50;
}

/* PP26-03 — swoosh hijau lebar, pojok kanan bawah */
.deco--03 {
  width: 360px;
  bottom: -30px;
  right: -50px;
  transform: rotate(-12deg);
  opacity: 0.55;
}

/* PP26-04 — zigzag kuning, tengah kiri */
.deco--04 {
  width: 140px;
  top: 38%;
  left: 3%;
  transform: rotate(8deg);
  opacity: 0.60;
}

/* PP26-05 — bintang putih, aksen kecil tengah atas */
.deco--05 {
  width: 72px;
  top: 8%;
  left: 50%;
  transform: translateX(-50%) rotate(15deg);
  opacity: 0.45;
}

/* PP26-06 — kurva oranye, pojok kiri bawah */
.deco--06 {
  width: 260px;
  bottom: 0px;
  left: -20px;
  transform: rotate(12deg);
  opacity: 0.55;
}

/* PP26-07 — elips biru, sisi kanan tengah */
.deco--07 {
  width: 170px;
  top: 42%;
  right: 2%;
  transform: rotate(25deg);
  opacity: 0.50;
}

/* PP26-08 — elips pink, sisi kiri bawah tengah */
.deco--08 {
  width: 150px;
  bottom: 22%;
  left: 5%;
  transform: rotate(-20deg);
  opacity: 0.48;
}

/* PP26-09 — dua dot kuning+merah, aksen kanan bawah */
.deco--09 {
  width: 90px;
  bottom: 10%;
  right: 6%;
  transform: rotate(-10deg);
  opacity: 0.65;
}

/* Responsive — sedikit kecilkan &  geser agar tidak blocking konten mobile */
@media (max-width: 768px) {
  .deco--01 { width: 200px; }
  .deco--02 { width: 180px; }
  .deco--03 { width: 220px; }
  .deco--04 { width: 90px; left: -5px; }
  .deco--05 { width: 50px; }
  .deco--06 { width: 160px; }
  .deco--07 { width: 110px; }
  .deco--08 { width: 100px; }
  .deco--09 { width: 65px; }
}

.content-scroll-wrapper {
  /* Wrapper konten tidak memerlukan style khusus, ia akan berjalan normal */
  min-height: 100vh;
}

/* --- Wrapper & Judul --- */
.quiz-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 2rem;
}

.progress-header {
  width: 100%;
  max-width: 600px;
  margin-bottom: -1rem;
}

/* .main-title {
  text-align: center;
  font-size: clamp(1.25rem, 5vw, 1.75rem);
  margin-bottom: 1rem;
  color: #f8f9fa;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}//// */

.main-title {
  font-family: 'Epilogue', sans-serif;
  font-weight: 900;
  text-align: center;
  font-size: clamp(1.25rem, 5vw, 1.75rem);
  margin-bottom: 1rem;
  color: #26488a;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: 1.5px;
  text-transform: uppercase;
}

/* --- Progress Bar --- */
.progress-bar-container {
  width: 100%;
  height: 8px; /* Memberi ketebalan pada wadah/track */
  background-color: rgba(255, 255, 255, 0.3); /* Warna track transparan */
  border-radius: 4px;
  overflow: hidden; /* Penting agar isinya tidak keluar dari radius */
}

.progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #4489C6, #F0D25B);
  border-radius: 4px;
  transition: width 0.4s ease;
}

/* --- Tombol Navigasi (Back/Next/Finish) --- */
.navigation-buttons {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 600px;
  margin-top: 1rem; /* Diberi jarak lebih dari kartu */
}

.nav-button {
  background-color: #fff;
  color: #2c3e50;
  border: none;
  padding: 12px 28px;
  font-family: 'Epilogue', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.nav-button.next-button {
  background-color: #4489C6;
  color: white;
  box-shadow: 0 4px 15px rgba(68, 137, 198, 0.35);
}

.nav-button.finish-button {
  background-color: #78BE95;
  color: white;
  box-shadow: 0 4px 15px rgba(120, 190, 149, 0.4);
}

.nav-button:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.nav-button.finish-button:hover:not(:disabled) {
  box-shadow: 0 6px 20px rgba(120, 190, 149, 0.55);
}

.nav-button:disabled {
  background-color: #bdc3c7;
  color: #7f8c8d;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* --- Container Status (Loading/Error) --- */
.status-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  height: 400px;
}

.status-container.error h2 {
  color: #DF654D;
}

.retry-button {
  margin-top: 1.5rem;
  padding: 10px 20px;
  border: 2px solid white;
  background: transparent;
  color: white;
  font-family: 'Epilogue', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.retry-button:hover {
  background: white;
  color: #2980B9;
}

/* --- Animasi Transisi Antar Kartu --- */
.slide-fade-enter-active {
  transition: all 0.4s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(30px);
  opacity: 0;
}
/* Penyesuaian untuk Mobile */
@media (max-width: 480px) {
  .main-title {
    font-size: 1.1rem;
  }
}
</style>